import { render, staticRenderFns } from "./LotteryResults.vue?vue&type=template&id=f983535e&scoped=true&"
import script from "./LotteryResults.vue?vue&type=script&lang=js&"
export * from "./LotteryResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f983535e",
  null
  
)

export default component.exports